<template>
    <div>
        
<div class='container'>
  <!--input列表 -->
  <div class='input-box'>
    <div class="section">
      <span>券编码:</span>
      <input placeholder='请输入券编码' type='text'   v-model="cardNo"  />
    </div>
    <div class="section">
      <span>密码:</span>
      <input placeholder='请输入密码' type="text" :password="!open" maxlength='11' v-model="password"/>
      <!-- <img style="width:35px;height: 20px;" :src="open?'http://img.zhujiaxian.com/2023/05/12865fe9b0f143c7bfa2e4850d4a8100.png':'http://img.zhujiaxian.com/2023/05/a8456f1291dd41758842204e459caadf.png'"   mode="aspectFill"/> -->
    </div>
  </div>
  <!-- end input列表 -->
  <!-- 功能按钮 -->
  <div class='btn-box'>
    <div class='keep btn' @click='saveCard' >
      <span>激活</span>
    </div>
  </div>
  <!-- end 功能按钮 -->
</div>

    </div>
</template>
<script>
import { Getexchange} from "@/https/http";
export default {
    data(){
        return{
            cardNo:'',
            password:'',
            open: false,//默认不显示密码
        }
    },
    methods:{
        switch(){
            this.open = !this.open
        },
        saveCard(){
            console.log(this.cardNo,'saveCard',this.password);
            let data = {
                cardNo: this.cardNo,
                password: this.password
            }
            Getexchange(data).then(res=>{
                console.log(res.data);
                this.$toast.fail(res.data);
            }).catch(err=>{
                this.$toast.fail(err.data);
            })
        },
    }
}
</script>
<style lang="less" scoped>
/* pages/editAddress/editAddress.wxss */

page {
  background: #F7F7F7;
}
.container{
 height: 100%;
 padding: 10px;
 box-sizing: border-box;
 color: #333;
 font-family: helvetica,'Heiti SC',PingFangSC-Light;
 margin: 15px;
 background-color: #fff;
 border-radius: 12px;
}
/* input列表 */

.input-box {
  margin-bottom: 25px;
  background: #fff;
  padding: 0 10px;
}

.input-box .section {
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 14px;
  padding: 15px 0;
  line-height: 24px;
  height: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #e5e5e5;
}

.input-box .section span {
  width: 20%;
  color: #333;
}

.input-box .section input {
  width: 70%;
  padding: 0 10px;
  color: #333;
  border: 0px;
}

.input-box .section picker {
  width: 70%;
  padding: 0 15px;
}

.input-box .section .pca {
  width: 70%;
  padding: 0 10px;
}

.input-box .section .arrow {
  width: 14px;
  height: 14px;
}

.input-box .section .arrow img {
  width: 100%;
  height: 100%;
  vertical-align: top;
}

/* end input列表 */

/* 功能按钮 */

.btn-box {
  padding: 5px 0;
  width: 100%;
  text-align: center;
  margin: auto;
}

.btn-box span {
  font-size: 15px;
}

.btn-box .clear.btn, .keep.btn {
  width: 60%;
  height: 40px;
  line-height: 40px;
  margin: auto;
  text-align: center;
  border-radius: 25px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05), 0 1px 0 rgba(255, 255, 255, 0.3);
}

.btn-box .keep {
  color: #fff;
  /* background-color: #e43130; */
  background-image: linear-gradient(to right, #F35151 , #F38364);
}

.btn-box .clear.btn {
  margin-top: 20px;
  color: #e43130;
  background-color: #f8f0f1b6;
}

/* end 功能按钮 */

.infoText {
  margin-top: 10px;
  text-align: center;
  width: 100%;
  justify-content: center;
}

picker-view {
  background-color: white;
  padding: 0;
  width: 100%;
  height: 140px;
  bottom: 0;
  position: fixed;
}

picker-view-column view {
  vertical-align: middle;
  font-size: 14px;
  line-height: 14px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.animation-element-wrapper {
  display: flex;
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;
}

.animation-element {
  display: flex;
  position: fixed;
  width: 100%;
  height: 235px;
  bottom: 0;
  background-color: rgba(255, 255, 255, 1);
}

.animation-button {
  top: 10px;
  width: 145px;
  height: 50px;
  align-items: center;
}

picker-view span {
  color: #999;
  display: inline-flex;
  position: fixed;
  margin-top: 10px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  font-size: 17px;
  font-family: Arial, Helvetica, sans-serif;
}

.left-bt {
  left: 15px;
}

.right-bt {
  right: 10px;
  top: 10px;
  position: absolute;
  width: 40px !important;
}

.line {
  display: block;
  position: fixed;
  height: 1px;
  width: 100%;
  margin-top: 44px;
  background-color: #eee;
}

</style>